import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServiceEstimateComponentService {

  constructor(private http: HttpClient) { }
  getComponentHistory(id: any) {
    return this.http.get<any>(`/api/ServiceEstimateComponents/${id}/history`);
  }
  getComponentHistoryItem(id: number) {
    return this.http.get<any>(`/api/ServiceEstimateComponents/${id}/historyItem`);
  }

  getComponentDetailsByServiceEstimateId(serviceEstimateId: string) {
    return this.http.get<any>(`/api/ServiceEstimateComponents/${serviceEstimateId}/componentDetails`);
  }

}
